/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ServerStatus {
    ONLINE = 'online',
    OFFLINE = 'offline',
    INITIALIZING = 'initializing'
}

export function ServerStatusFromJSON(json: any): ServerStatus {
    return ServerStatusFromJSONTyped(json, false);
}

export function ServerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServerStatus {
    return json as ServerStatus;
}

export function ServerStatusToJSON(value?: ServerStatus | null): any {
    return value as any;
}

